import { useEffect } from "react";
import { motion } from "framer-motion";
import { FaExclamationCircle, FaCheckCircle, FaTimes } from "react-icons/fa";

const CustomNotification = ({ id, type, message, autoClose, onClose }) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose(id);
      }, 5000); // Auto close after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [autoClose, id, onClose]);

  return (
    <motion.div
      className={`fixed flex items-center justify-between w-80 p-4 rounded-lg shadow-xl backdrop-blur-md bg-opacity-80 
        ${type === "error" ? "bg-red-500/20 text-red-600 border border-red-400" : "bg-green-500/20 text-green-600 border border-green-400"}
      `}
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
      style={{ bottom: `${1 + id * 6}rem`, right: "1rem", zIndex: 50 }}
    >
      <div className="flex items-center">
        {type === "error" ? (
          <FaExclamationCircle className="mr-3 text-xl" />
        ) : (
          <FaCheckCircle className="mr-3 text-xl" />
        )}
        <span className="text-sm font-medium">{message}</span>
      </div>

      <button
        className="ml-4 text-gray-500 hover:text-gray-800"
        onClick={() => onClose(id)}
      >
        <FaTimes />
      </button>

      {/* Progress Bar for Auto Close */}
      {autoClose && (
        <motion.div
          className={`absolute bottom-0 left-0 h-1 w-full ${
            type === "error" ? "bg-red-500" : "bg-green-500"
          }`}
          initial={{ width: "100%" }}
          animate={{ width: 0 }}
          transition={{ duration: 5, ease: "linear" }}
        />
      )}
    </motion.div>
  );
};

export default CustomNotification;
